import axios from 'axios';


 const axiosInstance = axios.create({
   //  baseURL:"http://127.0.0.1:5001/clone-666ba/us-central1/api"
    baseURL:"https://amazon-clone-back-u1rp.onrender.com",
 });



 export{axiosInstance};